<div>
    <br>
    <br>
    <p-select ngDefaultControl [options]="dataCategories" [(ngModel)]="selectedDataCategory" optionLabel="title" appendTo="body" placeholder="Category"/>
    <p>

    <div class="form-field">
        <!--NEBULAR FIX noWhiteSpace-->
        <input pInputText [placeholder]="'model_new'| translation" noWhiteSpace #newModelName="ngModel" ngDefaultControl [(ngModel)]="newModel">
    </div>
    &nbsp;&nbsp;
    <button pButton severity="primary" (click)="createModel()" [disabled]="!selectedDataCategory || alreadyExists() || newModelName.invalid">{{'add'| translation}}</button>
</div>
<div style="color:red;" *ngIf="alreadyExists()">{{'model_already_exist'| translation}}.</div>
<div style="color:red;" *ngIf="newModelName.errors && newModelName.errors.noWhiteSpace">{{'model_no_white_space'| translation}}.
</div>